import { headerItemStackSX } from '@/components/content/Header/styles/itemStack';
import {
	headerMiniCartContainerSX,
	iconCountCartSX,
	numberCountCartSX,
} from '@/components/content/Header/styles/miniCart/container';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { HeaderMiniCartDrawerMenuV2 } from '@/components/content/Header/parts/HeaderMiniCartDrawerMenuV2';
import { Stack, Typography } from '@mui/material';
import { FC, MouseEventHandler } from 'react';

type Props = {
	open: boolean;
	count: number;
	handleToolTip: (action: string) => () => void;
	onMouseEnter: MouseEventHandler<HTMLDivElement>;
	onDeleteCart: () => Promise<void>;
};

export const HeaderMiniCartMobile: FC<Props> = ({ open, count, handleToolTip, onDeleteCart }) => (
	<>
		<Stack sx={headerMiniCartContainerSX}>
			<Stack alignItems="center" onClick={handleToolTip('open')} sx={headerItemStackSX}>
				<Stack sx={{ alignItems: 'center', paddingTop: '0px' }}>
					{count > 0 ? (
						<Typography sx={numberCountCartSX({ isMobile: true })}>{count}</Typography>
					) : null}
					<ShoppingCartIcon sx={iconCountCartSX({ isMobile: true, isItemsCount: count > 0 })} />
				</Stack>
			</Stack>
		</Stack>
		{open ? (
			<HeaderMiniCartDrawerMenuV2 onClose={handleToolTip('close')} onDeleteCart={onDeleteCart} />
		) : null}
	</>
);
